import GeneralHelper from "../../../common/helpers/GeneralHelper";
import BrandService from "../../../common/services/catalog/BrandService";
import CategoryService from "../../../common/services/catalog/CategoryService";
import ProductService from "../../../common/services/catalog/ProductService";
import ProductTypeService from "../../../common/services/catalog/ProductTypeService";
import ConditionService from "../../../common/services/kit/ConditionService";
import DraftService from "../../../common/services/kit/DraftService";
import KitFileService from "../../../common/services/kit/KitFileService";
import KitService from "../../../common/services/kit/KitService";
import axios from "../../../common/utils/axios";
import {
    ADD_FILE,
    ADD_MEDIA,
    ADD_TO_WATCHLIST,
    GET_CATEGORY_SPECS,
    POST_KIT,
    REMOVE_FROM_WATCHLIST,
    REMOVE_MEDIA,
    SELL_GET_KIT,
    SELL_SET_EDIT_MODE,
    SELL_SET_KIT_FROM_SEARCH,
    SELL_SET_KIT_ID,
    SELL_SET_RFP_ID,
    SELL_SET_THUMBNAIL,
    SET_FORM_2_SCHEMA,
    SWITCH_SELL_FORM,
    SET_QUOTED_RFP_ID,
    GET_CATEGORY_BY_ID,
    GET_MATCHING_RFPS,
    SELL_AI_CHAT,
    SELL_AI_CHAT_STATUS,
    SUGGEST_KIT_ACCESSORIES,
    SELL_AI_CHAT_PROGRESS
} from "./actions";
import { GET_CUSTOMER_LISTINGS } from "../../userdashboard/store/listing/actions";
import AuthHelper from "../../../common/helpers/AuthHelper";
export default {
    state: {
       
        isSellSearchVisible:true,
        productFromSearch:false,
        kitFromImage:false,
        matchingRfps: [],
        suggestProduct: {
            display: false,
            types: [],
            categories: [],
            brands: [],
        },
        listingTable: {
            products: [],
            selectedProducts: [],
            conditionOptions: [],
        },
        suggestedItem: {
            productName: "",
            items: [],
        },
        searchResult: {
            products: [],
        },

        suggestedAccessories:[],
        
        Price: {
            value: undefined,
            currency: 1,
        },
        FromName: {
            InfoFromName: "",
        },
        MainItem: {
            displaySpecs:[]
        },
        SellVisible: false,
        sellEditMode: false,
        sellContext: undefined,
        Rent: [{
                name: "$/M",
            },
            {
                name: "$/Y",
            },
            {
                name: "$/H",
            },
            {
                name: "$/W",
            },
        ],
        warranty: [{
            name: "Mth",
        }, ],
        form2Schema: undefined,
        form1Schema: undefined,
        informationListing: {
            id: undefined,
            is_draft: true,
            Title: undefined,
            Keywords: undefined,
            Description: undefined,
            quantity:1,
            sales_percentage:0,
            sale_start: new Date().toJSON(),
            sale_end: new Date().toJSON(),
            sold: false,
            negotiation: false,
            accessories:[],
            rentals: [
                false,
                {
                    name: "$/M",
                },
                "",
            ],
            Warranty: [false, 0],
            youtubelink: "",
            quoted_rfp_id: null,
            kit_source_id: 1,
            is_consignment: false,
            service_center_id: null,
            service_center_name: null,
            
        },
        SelectedImages: [],
        SelectedFiles: [],
        Thumb: undefined,
        Step: 0,
        suggestedData: undefined,
        suggestedParams: undefined,
        suggestedIndex: undefined,
        quotedRfpId: null,
        categoryRouteName: null,
        CategoryDescription: null,
        customSpecs:[],
        specBrands:[],
        kitDimensions:{
            weight: 0,
            length: 0,
            width: 0,
            height: 0
        },
        kitLocation:{
            city: "",
            state: "",
            country: "",
            street_name: "",
            zip: ""
        },
        kitSources:[],
        kitChat:[
            // {is_processing:true}
        ],
        kitChatStatus:"start",
        kitChatProgress:{
            progress:10,
            message: "Uploading Images"
        },
        
    },
    getters: {
        suggestedAccessories: (state) =>  state.suggestedAccessories,
        kitChat: (state) =>  state.kitChat,
        kitChatStatus: (state) =>  state.kitChatStatus,
        kitChatProgress: (state) =>  state.kitChatProgress,
        matchingRfps:(state) =>
        {
            return state.matchingRfps
        },
        kitSources:(state) =>
        {
            return state.kitSources
        },
        kitFromImage:(state) =>
        {
            return state.kitFromImage
        },
        customSpecs:(state) =>
        {
            return state.customSpecs
        },

        kitDimensions:(state) =>
        {
            return state.kitDimensions
        },
        kitLocation:(state) =>
        {
            return state.kitLocation
        },
        isSellSearchVisible: (state) =>
        {
            return state.isSellSearchVisible
        },
        
        productFromSearch: (state) =>
        {
            return state.productFromSearch
        },
        suggestedData: (state) => {
            return state.suggestedData;
        },
        suggestedParams: (state) => {
            return state.suggestedParams;
        },
        suggestedIndex: (state) => {
            return state.suggestedIndex;
        },
        kitImagesPath: (state) => {
            return "/storage/kits/";
        },
        Step: (state) => {
            return state.Step;
        },
        suggestdisplay: (state) => {
            return state.suggestProduct.display;
        },
        Categories: (state) => {
            return state.suggestProduct.categories;
        },
        Brands: (state) => {
            return state.suggestProduct.brands;
        },
        Types: (state) => {
            return state.suggestProduct.types;
        },
        listedProduct: (state) => {
            return state.listingTable.products;
        },
        SelectedProducts: (state) => {
            return state.listingTable.selectedProducts;
        },
        conditionOptions: (state) => {
            return state.listingTable.conditionOptions;
        },
        suggestedItem1: (state) => {
            return state.suggestedItem;
        },
      
        kitPrice: (state) => {
            return state.Price;
        },
        SellVisible: (state) => {
            return state.SellVisible;
        },

        searchResult: (state) => {
            return state.searchResult.products;
        },

        MainItem: (state) => {
            return state.MainItem;
        },
        currency1: (state) => {
            return state.currency;
        },
        Rent: (state) => {
            return state.Rent;
        },
        Warranty: (state) => {
            return state.warranty;
        },
        sellKitId: (state) => {
            return state.informationListing.id;
        },
        sellKitIsDraft: (state) => {
            return state.informationListing.is_draft;
        },
        information: (state) => {
            return state.informationListing;
        },
        FromName: (state) => {
            return state.FromName.InfoFromName;
        },
        SelectedImages: (state) => {
            return state.SelectedImages;
        },
        SelectedFiles: (state) => {
            return state.SelectedFiles;
        },
        Thumb: (state) => {
            return state.Thumb;
        },
        form2Schema: (state) => {
            return state.form2Schema;
        },
        sellEditMode: (state) => {
            return state.sellEditMode;
        },
        quotedRfpId: (state) => {
            return state.quotedRfpId;
        },
        categoryRouteName: (state)=>{
            return state.categoryRouteName;
        },
        categoryDescription: (state)=>{
            return state.categoryDescription;
        },
        specBrands:(state)=>{
            return state.specBrands;
        }
    },
    mutations: {
        [SUGGEST_KIT_ACCESSORIES]:(state, data) =>
        {
            state.suggestedAccessories = data
        },
        getKitSources:(state, data) =>
        {
            state.kitSources = data
        },
        setCustomSpecs: (state, data) =>
        {
            state.customSpecs = data
        },
        setKitDimensions: (state, data) =>
        {
            state.kitDimensions = data
        },

        setKitLocation: (state, data) =>
        {
            state.kitLocation = data
        },
        setSpecBrands: (state, data) =>
        {
            state.customSpecs = data
        },
        setCategoryRouteName:(state, name)=>{
            state.categoryRouteName = name;
        },

        setKitFromImage:(state, name)=>{
            state.kitFromImage = name;
        },

        
        setCategoryDescription:(state, name)=>{
            state.categoryDescription = name;
        },
        setIsSellSearchVisible: (state, boolean) =>
        {
            state.isSellSearchVisible = boolean
        },
        setIsProductFromSearch: (state, boolean) =>
        {
            state.productFromSearch = boolean
        },
        setSellContext: (state, ctx) => {
            state.sellContext = ctx;
        },
        [GET_MATCHING_RFPS]: (state, data) => {
            state.matchingRfps = data;
        },
        [SELL_SET_EDIT_MODE]: (state, sellEditMode) => {
            state.sellEditMode = sellEditMode;
        },
        [SET_FORM_2_SCHEMA]: (state, data) => {
            state.form2Schema = data;
        },
        [SELL_SET_KIT_ID]: (state, id) => {
            state.informationListing.id = id;
        },

        [SET_QUOTED_RFP_ID]: (state, rfp_id) =>{
            state.quotedRfpId = rfp_id;
        },

        [SELL_GET_KIT]: (state, data) => {
            state.listingTable.products = [];
            state.informationListing.Title = data.title;
            state.informationListing.Description = data.description;
            state.informationListing.kit_source_id = data.sourceId            
            state.informationListing.quantity = data.quantity;
            state.informationListing.sales_percentage = data.salesPercentage;
            state.informationListing.sale_start = data.sale_start;
            state.informationListing.sale_end = data.sale_end;
            state.informationListing.service_center_id = data.service_center_id;
            state.informationListing.service_center_name = data.service_center_name;
            state.informationListing.accessories = JSON.parse(data.accessories);

            state.informationListing.negotiation = true;
            state.informationListing.is_consignment = false;
            state.informationListing.id = data.id;
            state.informationListing.is_draft = data.is_draft;
            state.informationListing.Warranty = [
                (data.warranty && data.warranty != null && data.warranty) > 0 ?
                true :
                false,
                data.warranty == null ? undefined : data.warranty,
            ];

            state.informationListing.youtubelink = data.youtubelink;
            if(data.custom_specs)
            {
                state.customSpecs = JSON.parse(data.custom_specs);
                for (let i = 0; i< state.customSpecs.length; i++)
                {
                    state.customSpecs[i]['value'] = state.customSpecs[i]['value'].toString()
                }
           
            }


            state.Price.value = data.price;
            state.Price.currency = data.currency_id;
            state.SelectedImages = data.images;
            state.SelectedFiles = data.files;

            state.kitDimensions.weight = data.weight;
            state.kitDimensions.length = data.length;
            state.kitDimensions.width = data.width;
            state.kitDimensions.height = data.height;

            state.kitLocation.city = data.city;
            state.kitLocation.state = data.state;
            state.kitLocation.country = data.country;
            state.kitLocation.street_name = data.street_name;
            state.kitLocation.zip = data.zip;

            console.log(data)
            data.items.forEach(function(item) {
                var product = {
                    id: item.product.id,
                    brandName: item.product.brand.name,
                    productName: item.product.name,
                    productId: item.product.id,
                    categoryId: item.product.category.id,
                    brandId: item.product.brand.id,
                    typeId: item.product.product_type.id,
                    categoryName: item.product.category.name,
                    typeName: item.product.product_type.name,
                    hasSerial: item.product.product_type.has_serial,
                    hasYear: item.product.product_type.has_year,
                    hasCondition: item.product.product_type.has_condition,
                    canChangeQuantity: item.product.product_type.can_change_quantity,
                    modelNumber:item.product.model_number

                };

                let specs = item.product.specs

                let displaySpecs = []

                for(let i=0;i<specs.length;i++)
                {
                    let spec = specs[i]
                    let name = spec.name
                    let value = Array.isArray(spec.values)&&spec.values.length?spec.values[0].value:""
                  
                    let clearSpec = spec.tags.length ? spec.tags.some(tag => tag.name === "clear_on_match") : false

                    if (clearSpec) value = ""
                    displaySpecs.push({name:name,value:value})
                }

                product.displaySpecs = displaySpecs

                var i = {
                    is_main: item.is_main,
                    product: product,
                    qty: item.qty,
                    year: item.year,
                    serial: item.serial_number,
                    condition: item.condition_id,
                    id: item.id,
                };

                if (i.is_main) state.MainItem = i.product;

                i.code = GeneralHelper.makeid(6);

                state.listingTable.products.push(i);
            });
        },
        setListedProducts(state, data) {
            state.listingTable.products = data;
        },
        nextStep(state) {
            state.Step++;
        },
        backStep(state) {
            if (state.Step > 0) state.Step--;
        },
        setMainItem(state, main_item) {
            state.MainItem = main_item;
        },
        setSuggestdisplay(state, display) {
            state.suggestProduct.display = display;
        },
        setCategories(state, categories) {
            state.suggestProduct.categories = categories;
        },
        setBrands(state, brands) {
            state.suggestProduct.brands = brands;
        },
        setTypes(state, types) {
            state.suggestProduct.types = types;
        },
        setSuggestedItems(state, products) {
            state.suggestedItem.items = products;
        },
        setSuggestedName(state, name) {
            state.suggestedItem.productName = name;
        },
        setSearchResults(state, products) {
            state.searchResult.products = products;
        },
        setSuggestData(state, data) {
            state.suggestedData = data;
        },
        setSuggestParams(state, data) {
            state.suggestedParams = data;
        },
        setSuggestIndex(state, index) {
            state.suggestedIndex = index;
        },
        setSelectedList(state, selected) {
            state.listingTable.selectedProducts = selected;
        },
        setConditionOptions(state, options) {
            state.listingTable.conditionOptions = options;
        },
        FromName(state, name) {
            state.FromName.InfoFromName = name;
        },
        removeSuggestedItem(state, item) {
            let index = state.suggestedItem.items.findIndex((it) => {
                return it.id == item.id;
            });
            state.suggestedItem.items.splice(index, 1);
        },
        setKitPrice(state, data) {
            state.Price.value = data.value;
            state.Price.currency = data.currency;
        },
        SellVisible(state, visible) {
            state.SellVisible = visible;
        },

        Info(state, info) {
            state.Title = info.Title;
            state.Keywords = info.Keywords;
            state.Description = info.Description;
            state.sold = info.sold;
            state.negotiation = info.negotiation;
            state.rentals = info.rentals;
            state.Warranty = info.Warranty;
            state.is_consignment = info.is_consignment;
        },
        setSelectedImages(state, images) {
            state.SelectedImages = images;
        },
        setSelectedFiles(state, files) {
            state.SelectedFiles = files;
        },
        setThumb(state, thumb) {
            state.Thumb = thumb;
        },
        [POST_KIT]: (state, data) => {
            state.informationListing.id = data.id;
        },
        [SWITCH_SELL_FORM]: (state) => {
    
            state.isSellSearchVisible = true,
            state.suggestProduct = {
                display: false,
                types: [],
                categories: [],
                brands: [],
            };

            state.listingTable = {
                products: [],
                selectedProducts: [],
                conditionOptions: [
                    { id: 1, name: "New" },
                    { id: 2, name: "Used" },
                    { id: 3, name: "Refurbished" },
                ],
            };

            state.suggestedItem = {
                productName: "",
                items: [],
            };

            state.searchResult = {
                products: [],
            };

            state.sellRfpId = undefined;
            state.Price = {
                value: undefined,
                currency: 1,
            };
            state.FromName = {
                InfoFromName: "",
            };
            state.MainItem = {};
            state.sellEditMode = false;
            state.currency = [{
                    name: "$",
                },
                {
                    name: "£",
                },
                {
                    name: "€",
                },
                {
                    name: "AUD$",
                },
            ];
            (state.Rent = [{
                    name: "$/M",
                },
                {
                    name: "$/Y",
                },
                {
                    name: "$/H",
                },
                {
                    name: "$/W",
                },
            ]),
            (state.warranty = [{
                name: "Mth",
            }, ]);
            state.form2Schema = undefined;
            state.form1Schema = undefined;
            state.informationListing = {
                id: undefined,
                is_draft: true,
                Title: undefined,
                Keywords: undefined,
                Description: undefined,
                sold: false,
                negotiation: false,
                is_consignment: false,
                accessories:[],
                rentals: [
                    false,
                    {
                        name: "$/M",
                    },
                    "",
                ],
                Warranty: [false, undefined],
            };
            state.SelectedImages = [];
            state.SelectedFiles = [];
            state.Thumb = undefined;
            state.Step = 0;
        },
        [ADD_MEDIA]: async(state, image) => {
            state.SelectedImages.push(image);
        },
        [ADD_FILE]: async(state, image) => {
            state.SelectedFiles.push(image);
        },
        [SELL_SET_THUMBNAIL]: async(state, id) => {
            for (var i = 0; i < state.SelectedImages.length; i++) {
                state.SelectedImages[i].is_main = false;
                if (state.SelectedImages[i].id == id)
                    state.SelectedImages[i].is_main = true;
            }
        },
        [SELL_AI_CHAT]: (state, chat) => {
            state.kitChat = chat;
        },
        [SELL_AI_CHAT_STATUS]: (state, status) => {
            state.kitChatStatus = status;
        },
        [SELL_AI_CHAT_PROGRESS]: (state, status) => {
            state.kitChatProgress = status;
        },
    },
    actions: {

        [SELL_AI_CHAT]: async(context, data) => {
            var kitService = new KitService();
            let data1 = {
                chat:data.chat,
                base64Images: data.base64Images,
                current_step:context.getters.rfpChatStatus
            }

            var res = await kitService.createFromChatStream(data1);

            let reader = res.body.getReader();
            let decoder = new TextDecoder('utf8');
            let result;
            while (!result?.done) {
                result = await reader.read();
                let chunk = decoder.decode(result.value);
                if (!chunk) break
                var sanitized = '[' + chunk.replace(/}{/g, '},{') + ']';
                let json = JSON.parse(sanitized)

                json = json[json.length - 1]

                context.commit(SELL_AI_CHAT, json.data.chat)
                context.commit(SELL_AI_CHAT_STATUS, json.data.current_step)
            }

            
            if (context.getters.sellChatStatus == 'process_kit')
            {
                let data1 = {
                    chat:context.getters.kitChat.slice(),
                    current_step:context.getters.kitChatStatus
                }
                let chat = context.getters.kitChat.slice()
                chat.push({role:"assistant", content:``, is_processing:true})
                context.commit(SELL_AI_CHAT, chat)

                var res = await kitService.createFromChatStream(data1);

                reader = res.body.getReader();
                decoder = new TextDecoder('utf8');
                result = undefined;
                while (!result?.done) {
                    result = await reader.read();
                    let chunk = decoder.decode(result.value);
                    if (!chunk) break
                    var sanitized = '[' + chunk.replace(/}{/g, '},{') + ']';
                    let json = JSON.parse(sanitized)
                    json = json[json.length - 1]
                    chat = json.data.chat
                    chat.push({role:"assistant", content:`Your Request is ready. Go to ${GeneralVariables.URL + 'en/post-request/edit/' + json.data.rfp.id}` })
                    context.commit(SELL_AI_CHAT, chat)
                    context.commit(SELL_AI_CHAT_STATUS, json.data.current_step)
                }

                
            }
            return result;
        },

        [SUGGEST_KIT_ACCESSORIES]:async (context)=>{
            var kitService = new KitService()
            await kitService.suggestAccessories(context.getters.information.Title, JSON.stringify(context.getters.information.accessories)).then((result)=>{
                context.commit(SUGGEST_KIT_ACCESSORIES, result.data)
            })
        },

        getKitSources(context){
            var kitService = new KitService()
            kitService.getKitSources().then((result)=>{
                context.commit('getKitSources', result.data.data)
            })
        },

        setSpecBrands(context){
            var brandService = new BrandService()
            brandService.getSpecBrands().then((result)=>{
                context.commit('setSpecBrands', result.data.data)
            })
        },

        updateTableListing(context, data) {
            context.state.listingTable.products.splice(
                context.state.suggestedIndex,
                1
            );
            context.state.listingTable.products.push(data)
        },
        setProductsList(context, products) {
            let checkifexist = -1;

         
                products.is_main = true;
                context.state.MainItem = products.product;
                var productService = new ProductService();
                productService.getSuggestions(products.product.id).then((result) => {
                    context.commit("setSuggestedItems", result.data.data);
                });
         

            for (let i = 0; i < context.state.listingTable.products.length; i++) {
                if (
                    context.state.listingTable.products[i].product.productName ===
                    products.product.productName
                ) {
                    if (
                        context.state.listingTable.products[i].is_main == false &&
                        context.state.listingTable.products[i].product.canChangeQuantity
                    )
                        checkifexist = i;
                }
            }
            if (checkifexist != -1) {
                if (products.product.canChangeQuantity) {
                    context.state.listingTable.products[checkifexist].qty++;
                    return;
                }
            }
            products.code = GeneralHelper.makeid(6);
            context.state.listingTable.products.push(products);
        },
        
        [GET_MATCHING_RFPS]: async(context, id) => {
            let kitService = new KitService()
            let result = await kitService.getMatchingRFPs(id)
            context.commit(GET_MATCHING_RFPS, result.data.data??[])
            console.log(context.getters.matchingRfps)
            return result
        },
        [SWITCH_SELL_FORM]: (context) => {
            if (!AuthHelper.checkAuthForAction(context)) return;
            context.commit(SWITCH_SELL_FORM);
        },
        [GET_CATEGORY_SPECS]: async(context, id) => {
            var categoryService = new CategoryService();
            var result = await categoryService.getSpecs(id);
            return result.data.data;
        },

        [GET_CATEGORY_BY_ID]: async(context, id) => {
            var categoryService = new CategoryService();
            var result = await categoryService.findById(id);
            return result.data;
        },
        [REMOVE_MEDIA]: async(context, id) => {
            var kitFileService = new KitFileService();
            var result = await kitFileService.delete(id);
            return result;
        },
        [ADD_MEDIA]: async(context, file) => {
            var kitService = new KitService();
            var d = {
                src: file,
                temp: 1,
                code: GeneralHelper.makeid(5),
            };

            context.commit(ADD_MEDIA, d);

            var fun = function(code) {
                kitService
                    .addImage(file, context.state.informationListing.id, {
                        success: GeneralHelper.buildMessage(1, "Image Uploaded"),
                        error: GeneralHelper.buildMessage(3, "Cannot upload this image"),
                    })
                    .then((r) => {
                        if (r.status == 200 || r.status == 201) {
                            for (var i = 0; i < context.state.SelectedImages.length; i++) {
                                if (context.state.SelectedImages[i].code == code) {
                                    context.state.SelectedImages.splice(i, 1, r.data.data);
                                }
                            }
                        } else {
                            for (var i = 0; i < context.state.SelectedImages.length; i++) {
                                if (context.state.SelectedImages[i].code == code) {
                                    context.state.SelectedImages.splice(i, 1);
                                }
                            }
                        }
                    });
            };
            fun(d.code);
        },
        [ADD_FILE]: async(context, file) => {
            var kitService = new KitService();
            var result = await kitService.addFile(
                file,
                context.state.informationListing.id, {
                    success: GeneralHelper.buildMessage(1, "File Uploaded"),
                    error: GeneralHelper.buildMessage(3, "Cannot upload this file"),
                }
            );
            context.commit(ADD_FILE, result.data.data);
            return result;
        },
        async getConditionsOptions(context) {
            var conditionService = new ConditionService();
            var data = await conditionService.get();
            context.commit("setConditionOptions", data.data);
        },
        initCategories(context) {
            return new Promise((resolve, reject) => {
                axios({
                        url: "categories",
                        method: "get",
                    })
                    .then((response) => {
                        context.commit("setCategories", response.data.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },

        async initBrands(context) {
            var brandService = new BrandService();
            var data = await brandService.get();
            context.commit("setBrands", data.data);
        },

        async initTypes(context) {
            var productTypeService = new ProductTypeService();
            var data = await productTypeService.get();
            context.commit("setTypes", data.data);
        },
        [SELL_SET_THUMBNAIL]: async(context, id) => {
            var kitFileService = new KitFileService();
            var result = await kitFileService.edit({
                id: id,
                is_main: 1,
            });
            context.commit(SELL_SET_THUMBNAIL, id);
        },
        [SELL_GET_KIT]: async(context, id) => {
            var kitService = new KitService();
            var result = await kitService.getById(id);
            context.commit(SELL_GET_KIT, result.data.data);
            return result;
        },
        [SELL_SET_KIT_ID]: async(context, id) => {
            context.commit(SELL_SET_KIT_ID, id);
            var kitService = new KitService();
            var result = await kitService.getById(
                context.state.informationListing.id
            );
            context.commit(SELL_GET_KIT, result.data.data);
            return result;
        },

        [SELL_SET_KIT_FROM_SEARCH]: async(context, id) => {
            let old_id = context.state.informationListing.id
            var kitService = new KitService();
            
            var result = await kitService.getById(
                id
            );
            
            context.commit(SELL_GET_KIT, result.data.data);
            context.commit(SELL_SET_KIT_ID, old_id);
            context.state.informationListing.is_draft = true
            

            let items = context.state.listingTable.products;
            for (let i = 0; i<items.length; i++)
            {
                delete items[i]['id']
                delete items[i].product['productId']
            }

            let main_items = []

            for (let i = 0; i<items.length; i++)
            {
                if (items[i]["is_main"] == true){
                    main_items.push(items[i])
                }
            }

            context.state.listingTable.products = main_items
            context.commit('setIsProductFromSearch',true)
            context.state.informationListing.Title = '';
            context.state.informationListing.Description = '';
            context.state.informationListing.sale_start = new Date().toJSON();
            context.state.informationListing.sale_end = new Date().toJSON();
            return result;
        },

        [ADD_TO_WATCHLIST]: (context, { kit_id }) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "customer/watchlist",
                        method: "post",
                        data: {
                            kit_id,
                        },
                    })
                    .then((response) => {
                        context.commit(ADD_TO_WATCHLIST, kit_id);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        [REMOVE_FROM_WATCHLIST]: (context, { kit_id }) => {
            return new Promise((resolve, reject) => {
                axios({
                        url: "customer/watchlist",
                        method: "delete",
                        data: {
                            kit_id,
                        },
                    })
                    .then((response) => {
                        context.commit(REMOVE_FROM_WATCHLIST, kit_id);

                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error.response);
                    });
            });
        },
        async searchCatalog(context, data) {
            var productService = new ProductService();
            var result = await productService.deepSearch({
                per_page: 25,
                value: data.search_string,
                cat_id: data.category,
            });
            context.commit("setSearchResults", result.data.data.data);
            return result;
        },

        async getSuggestions(context, data) {
            var productService = new ProductService();
            var result = await productService.getSuggestions(data.id);
            context.commit("setSuggestedItems", result.data.data);
        },

        async getProductSpecs(context, id) {
            var productService = new ProductService();
            var result = await productService.getSpecs(id);
            return result.data.data;
        },

        checkListings(context) {
            if (context.getters.listedProduct.length > 0) {
                return true;
            }
            return false;
        },
        [POST_KIT]: async(context, is_draft = null) => {
            let items = context.getters.listedProduct;
            var exit = true;

            items.forEach(function(item) {
                if (item.is_main) exit = false;
            });

            if (exit) return;

            let youtubelink =  context.getters.information.youtubelink
            let quoted_rfp_id = context.getters.quotedRfpId
            let customSpecs = context.getters.customSpecs
            let kitDimensions = context.getters.kitDimensions
            let kitLocation = context.getters.kitLocation

            let tags =
                context.getters.information.Keywords != undefined ?
                context.getters.information.Keywords.split(",") : [];

            var is_negotiable =
                context.getters.information.negotiation == null ||
                context.getters.information.negotiation == undefined ?
                false : context.getters.information.negotiation;

            var is_consignment =
                context.getters.information.is_consignment == null ||
                context.getters.information.is_consignment == undefined ?
                false : context.getters.information.is_consignment;

            var warranty =
                context.getters.information.Warranty[1] == null ||
                context.getters.information.Warranty[1] == undefined ?
                0 : context.getters.information.Warranty[1];

            let data = {
                items,
                tags,
                price: parseFloat(context.getters.kitPrice.value || 0),
                currency_id: context.getters.kitPrice.currency,
                title: context.getters.information.Title,
                description: context.getters.information.Description,
                kit_source_id: context.getters.information.kit_source_id,
                service_center_id: context.getters.information.service_center_id,
                warranty: warranty,
                is_negotiable: is_negotiable,
                youtubelink:youtubelink,
                quoted_rfp_id: quoted_rfp_id,
                custom_specs: customSpecs,
                quantity: context.getters.information.quantity,
                sales_percentage: context.getters.information.sales_percentage,
                sale_start: context.getters.information.sale_start,
                sale_end: context.getters.information.sale_end,
                is_consignment: is_consignment,
                weight: kitDimensions.weight,
                length: kitDimensions.length,
                width: kitDimensions.width,
                height: kitDimensions.height,

                city: kitLocation.city,
                state: kitLocation.state,
                country: kitLocation.country, 
                street_name: kitLocation.street_name,
                zip: kitLocation.zip,
                accessories:JSON.stringify(context.getters.information.accessories),            
            };
            if (context.getters.information.id != undefined)
                data.id = context.getters.information.id;

            var result = undefined;
            if (is_draft) {
                var draftService = new DraftService();
                if (context.getters.information.id != undefined)
                    result = await draftService.edit(data).then(() => {
                        context.dispatch(GET_CUSTOMER_LISTINGS);
                    });
                else
                    result = await draftService.create(data).then((response) => {
                        context.commit(SELL_SET_KIT_ID, response.data.id);
                        context.dispatch(GET_CUSTOMER_LISTINGS);
                    });
            } else {
                var kitService = new KitService();
                if (context.getters.information.id != undefined) {
                    result = await kitService.edit(data)
                    context.dispatch(GET_CUSTOMER_LISTINGS);
                } else {
                    result = await kitService.create(data);
                }
            }
            return result;
        },


        createFromImage: async(context, data) => {
           
            let kitService = new KitService()
            let result = await kitService.createKitFromImage({
                base64_images:data.base64Images,
                user_request: data.chat[0].content,
                signal: data.signal
            })
            context.commit(SELL_AI_CHAT_STATUS, 'end')
            return result;
        },

        createFromImageStream: async(context, data) => {
           
            context.commit(SELL_AI_CHAT_PROGRESS, {
                progress: 0,
                message: "Uploading Images"
            })

            let kitService = new KitService()

            let data1 = {
                base64_images:data.base64Images,
                user_request: data.chat[0].content,
                signal: data.signal
            }

            var res = await kitService.createKitFromImageStream(data1);

            let reader = res.body.getReader();
            let decoder = new TextDecoder('utf8');
            let result;
            console.log("TEST START")
            while (!result?.done) {
                console.log("READING")
                result = await reader.read();
                console.log("FOUND SOMETHING")
                let chunk = decoder.decode(result.value);
                console.log("HIII")
                console.log(chunk)
                console.log("BYE")
                if (!chunk) break
                var sanitized = '[' + chunk.replace(/}{/g, '},{') + ']';
                let json = JSON.parse(sanitized)
                for (let i = 0; i<json.length; i++)
                {
                    if ("progress" in json[i])
                    {
                        context.commit(SELL_AI_CHAT_PROGRESS, json[i])
                        console.log(json[i])
                    }
                    else
                    {
                        context.commit(SELL_AI_CHAT_STATUS, 'end')
                        context.commit(SELL_AI_CHAT_PROGRESS, {
                            progress: 0,
                            message: "Uploading Images"
                        })
                        return json[i]
                    }
                }

            }
            console.log("Done")
            return json;
        },
    },




    
};